import { useState } from 'react'
import { Container, TopLeft, BottomLeft, BottomRight, Hamburger, Center, Button, NavBar, NavMenu, CloseButton } from './styles'
import { CenterLogo } from './CenterLogo'
import Waitlist from './Waitlist'

export default function Overlay() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const openWaitlist = (e) => {
    e.preventDefault()
    setIsWaitlistOpen(true)
    setIsMenuOpen(false)
  }

  const closeWaitlist = () => {
    setIsWaitlistOpen(false)
  }

  return (
    <Container>
      <TopLeft>
        <h1>
          PEEL
          <br />
          IT ALL
        </h1>
        <p>FUN & PROFESSIONAL</p>
      </TopLeft>
      <BottomRight>
        <Button href="#waitlist" onClick={openWaitlist}>Waitlist</Button>
        <Button href="https://b00-2.gitbook.io/b.-docs/a2okzSxi6zxLx2uRVGWu/" target="_blank" rel="noopener noreferrer">Documentation</Button>
      </BottomRight>
      <Hamburger onClick={toggleMenu} isOpen={isMenuOpen}>
        <div />
        <div />
        <div />
      </Hamburger>

      {/* 居中的 SVG Logo */}
      <Center>
        <CenterLogo />
      </Center>

      {/* 导航栏 */}
      <NavBar isOpen={isMenuOpen}>
        <CloseButton onClick={toggleMenu}>×</CloseButton>
        <NavMenu>
          <li><a href="#home">Home</a></li>
          <li><a href="#waitlist" onClick={openWaitlist}>Waitlist</a></li>
          <li><a href="https://b00-2.gitbook.io/b.-docs/a2okzSxi6zxLx2uRVGWu/" target="_blank" rel="noopener noreferrer">Documentation</a></li>
        </NavMenu>
      </NavBar>

      {/* Waitlist 模态框 */}
      <Waitlist isOpen={isWaitlistOpen} onClose={closeWaitlist} />
    </Container>
  )
}
